import React from 'react'
import PropTypes from 'prop-types'
import cloneDeep from 'lodash.clonedeep';
import ReactEcharts from './ReactEcharts';

var replaceReg = /([&<>"'])/g;
var replaceMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  '\'': '&#39;'
};

function encodeHTML(source) {
  return source == null
  ? ''
  : (source + '').replace(replaceReg, function (str, c) {
    return replaceMap[c];
  });
}

class ParallelCoordinates extends React.Component {
  constructor(props) {
    super(props)
    this.lineStyle = {
      normal: {
        width: 0.5,
      }
    }
    this.itemStyle = {
      normal: {
      },
      emphasis: {
        barBorderWidth: 1,
        shadowBlur: 10,
        shadowOffsetX: 0,
        shadowOffsetY: 0,
        shadowColor: 'rgba(0,0,0,0.5)'
      }
    };

    this.state = this.getInitialState();
  }
  getInitialState = () => ({option: this.getOption()});

  componentWillReceiveProps(nextProps) {
    if (nextProps === this.props)
      return;
    this.updateChart(nextProps)
  }

  getOption = () => ({
    color: ['#fb8072', '#80b1d3', '#fdb462', '#b3de69', '#fccde5', '#d9d9d9',
      '#bc80bd', '#ccebc5', '#8dd3c7', '#ffffbc', '#bebada', '#ffed6f'],
    tooltip : {
      position: 'top',
      trigger: 'axis',
    },
    parallel: {
      top: 10,
    },
    textStyle: {
      fontSize: 12,
    },
    series: []
  });

  updateChart = (props) => {
    let {data, sizeFactor} = props;
    if(!sizeFactor) sizeFactor = 1;
    const option = cloneDeep(this.state.option); // immutable

    let itemCount = [0, ...data.slice(0,5)].reduce((a,b) => a+b.data.length);
    let totalCount = data[5].data.length;
    let darkLevel = 256 - Math.ceil(itemCount * 256 / totalCount);
    if(darkLevel > 192) darkLevel = 192;

    option.legend = {
      bottom: 30 * sizeFactor,
      //data: data.map(d => d.nameShort),
      data: data.map(d => d.nameShort).slice(0, 5),
      itemGap: 20 * sizeFactor,
    };
    option.parallelAxis = props.schema.map(s => ({
      dim: s.index,
      name: '', //s.text,
      type: this.props.distortScale ? s.type : 'value',
      //type: 'value',
      median: s.median,
      //ticks: [],
      ticks: s.ticks,
      axisTick: {
        show: false,
      },
      axisLabel: {
        show: false,
        fontSize: 12 * sizeFactor,
        //textBorderColor: '#FFF',
        //textBorderWidth: sizeFactor,
      },
      min: s.min,
      max: s.max,
      inverse: s.inverse ? s.inverse : false
    }));
    option.parallel.left = 80 * sizeFactor;
    option.parallel.right = 80 * sizeFactor;
    option.parallel.top = 10 * sizeFactor;
    option.parallel.bottom = 60 * sizeFactor;
    option.textStyle.fontSize = 12 * sizeFactor;
    option.series = data.map((d, index) => ({
      name: d.nameShort,
      type: 'parallel',
      inactiveOpacity: 0,
      activeOpacity: 0.01,
      progressive: 0,
      smooth: false,
      animation: false,
      lineStyle: this.lineStyle,
      itemStyle: this.itemStyle,
      z: data.length-index,
      data: d.data,
    }));

    // ugly settings
    option.series[0].z = 1;
    option.series[1].z = 2;
    option.series[2].z = 3;
    option.series[3].z = 4;
    option.series[4].z = 5;
    option.series[5].z = 0;
    option.series[6].z = 6;
    var call_count = 0;
    option.series[0].lineStyle.normal.color = (i) => {
      //return '#000';
      if(i.seriesIndex === 0)
        return '#fb8072';
      else if(i.seriesIndex === 1)
        return '#80b1d3';
      else if(i.seriesIndex === 2)
        return '#fdb462';
      else if(i.seriesIndex === 3)
        return '#b3de69';
      else if(i.seriesIndex === 4)
        return '#fccde5';
      else if(i.seriesIndex === 5)
        return `rgb(${darkLevel},${darkLevel},${darkLevel})`;
      else if(i.seriesIndex === 6)
        return '#000';
    };
    if(props.opacity) {
      option.series[0].lineStyle.normal.opacity = props.opacity;
    }
    else  {
      option.series[0].lineStyle.normal.opacity = this.props.height / itemCount;
      if(option.series[0].lineStyle.normal.opacity > 0.5)
        option.series[0].lineStyle.normal.opacity = 0.5;
    }
    option.series[0].lineStyle.normal.width = (darkLevel + 64) / 128;

    this.setState({
      option,
    });
  };

  onChartClick(params) {
    if(params.componentType !== 'series')
      return;
    if(this.props.onSelected)
      this.props.onSelected(params.dataIndex)
  }

  render() {
    let onEvents = {
      'click': this.onChartClick.bind(this),
    }
    return (
      <ReactEcharts ref='echarts_react'
        option={this.state.option}
        style={{width: this.props.width, height: this.props.height}}
        onEvents={onEvents}
      />
    )
  }
}
 
ParallelCoordinates.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.arrayOf(PropTypes.number)
  ).isRequired,
  onSelected: PropTypes.func,
}

export default ParallelCoordinates
